export default function getFavoritesPathname(userName) {
  return `/user/${userName}/favorites`;
}
